<!-- Questionnaire -->

<div class="m-t-20 m-b-60">

  <nz-table class="table-quest" [nzData]=[1,2,3] [nzScroll]="{ x:'1200px',y: '460px' }">
    <thead>
        <tr>
          <th class="main" nzLeft="0px" nzWidth="300px">Question</th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#FFF; background-color:#329ffd;" nzSize="small" nzIcon="anticon anticon-user"></nz-avatar>
              </div>
              <strong>Primary Insured</strong>
              <span>Mr. Chris Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Ms. Rachel Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Mr. Liam Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Mr. Luke Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Mr. Roger Hemsworth</span>
            </div>
          </th>
        </tr>
    </thead>

    <tbody>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">1. Do you smoke?</td>
          <td>
            <label nz-checkbox nzValue="A" name="isSmoker" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">2. What is your height? </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width"/> cms
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width"/> cms
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width"/> cms
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width"/> cms
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width"/> cms
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">3. Have you ever had child-birth related disorders? </td>
          <td>
            <span class="disabled">N/A</span>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
            <nz-select nzShowSearch  class="quest-input-width d-b" nzAllowClear nzPlaceHolder="Choose" ngModel="pre">
              <nz-option nzValue="eco" nzLabel="Ectopic"></nz-option>
              <nz-option nzValue="pre" nzLabel="Pre-term labor"></nz-option>
            </nz-select>
          </td>
          <td>
            <span class="disabled">N/A</span>
          </td>
          <td>
            <span class="disabled">N/A</span>
          </td>
          <td>
            <span class="disabled">N/A</span>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">4. Have you ever had any of the following conditions?</td>
          <td>
            <!-- Leave blank -->
          </td>
          <td>
            <!-- Leave blank -->
          </td>
          <td>
            <!-- Leave blank -->
          </td>
          <td>
            <!-- Leave blank -->
          </td>
          <td>
            <!-- Leave blank -->
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 a. Stroke, transient ischaemic attack (TIA), brain haemorrhage, brain aneurysm or other brain related injuries?
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 b. Chest Pain, Angio, heart attack, heart enlargement, heart failure or any other heart conditon?
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
          </td>
          <td>
            <label nz-checkbox nzValue="A" name="heart1" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" value="Chest Pain"/>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 c. Peripheral vascular or any disease or disorder of the aorta or arteries?
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 d. Asthama, bronchitis, pneumonia, tuberculosis, emphysems or any other breating / lung disorder?
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">
            5. Are you currently serving in the Armed Forces, or planning to in the future?
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
        </tr>

    </tbody>

  </nz-table>

</div>